// Cache vector paths, not raster sprites: identical vertices, compositing order,
// resolution and subpixel rendering without rebuilding thousands of arrays/frame.
export function polygonPath(points) {
  const path = new Path2D();
  path.moveTo(points[0][0], points[0][1]);
  for (let i = 1; i < points.length; i++) path.lineTo(points[i][0], points[i][1]);
  path.closePath();
  return path;
}

export function isometricCubePaths(size, isoX, isoY = .5) {
  const a = size * isoX, b = size * isoY;
  return {
    left: polygonPath([[-a, -b], [0, 0], [0, size], [-a, b]]),
    right: polygonPath([[0, 0], [a, -b], [a, b], [0, size]]),
    top: polygonPath([[0, -size], [a, -b], [0, 0], [-a, -b]]),
  };
}
